import { blendedLthrRaceMultiplier } from './racePredictionMetrics';
import { segmentMidpointCpPercent } from './runningSegmentLabels';

const SUSTAINED_CP_MIN = 78;
const SUSTAINED_DURATION_MIN = 10;
const RACE_REFERENCE_CP = 90;

function interpolateRaceHrAnchor(anchors, timeMin, field) {
  const pts = (anchors || [])
    .filter((a) => a[field] != null && Number.isFinite(a[field]) && Number.isFinite(a.durationMin))
    .map((a) => [a.durationMin, a[field]])
    .sort((a, b) => a[0] - b[0]);
  if (pts.length === 0) return null;
  if (pts.length === 1) return pts[0][1];
  if (timeMin <= pts[0][0]) return pts[0][1];
  const last = pts[pts.length - 1];
  if (timeMin >= last[0]) return last[1];
  for (let i = 0; i < pts.length - 1; i += 1) {
    const [t0, v0] = pts[i];
    const [t1, v1] = pts[i + 1];
    if (timeMin >= t0 && timeMin <= t1) {
      const w = (timeMin - t0) / (t1 - t0);
      return v0 + w * (v1 - v0);
    }
  }
  return null;
}

function segmentQualifiesForRaceHrProfile(seg, durationSec) {
  const ic = (seg.run_intensity_class || 'work').toLowerCase();
  if (ic !== 'work') return false;
  const cp = segmentMidpointCpPercent(seg);
  if (!Number.isFinite(cp) || cp < SUSTAINED_CP_MIN) return false;
  const durMin = Number(durationSec) / 60;
  if (!Number.isFinite(durMin) || durMin < SUSTAINED_DURATION_MIN) return false;
  return true;
}

export function blendSegmentBpmWithRaceProfile(baseBpm, seg, thresholdBpm, durationSec, raceHrProfile) {
  if (baseBpm == null || !Number.isFinite(baseBpm)) return baseBpm;
  if (!segmentQualifiesForRaceHrProfile(seg, durationSec)) return baseBpm;
  if (!raceHrProfile?.sampleCount || !Array.isArray(raceHrProfile.anchors) || raceHrProfile.anchors.length === 0) {
    return baseBpm;
  }
  if (thresholdBpm == null || !Number.isFinite(thresholdBpm) || thresholdBpm <= 0) return baseBpm;

  const durationMin = Number(durationSec) / 60;
  const cp = segmentMidpointCpPercent(seg);
  const mult = blendedLthrRaceMultiplier(durationMin, raceHrProfile);
  const cpScale = Math.pow(Math.max(45, Math.min(150, cp)) / RACE_REFERENCE_CP, 0.6);
  let raceBpm = thresholdBpm * mult * cpScale;

  const driftPct = interpolateRaceHrAnchor(raceHrProfile.anchors, durationMin, 'driftPct');
  if (driftPct != null && driftPct > 0) {
    raceBpm += raceBpm * (driftPct / 200) * 0.45;
  }

  raceBpm = Math.min(220, Math.max(80, Math.round(raceBpm)));
  const w = cp >= 88 ? 0.82 : cp >= 83 ? 0.65 : 0.45;
  return Math.min(220, Math.max(80, Math.round((1 - w) * baseBpm + w * raceBpm)));
}
